module.exports = __webpack_public_path__ + "static/sefastone-detail1-95e443358a4c2bb5c1cf2e13819d042b.png";